@import 'styles/mixins';
@import 'styles/variables';

.stepsContainer {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4px;

  .step {
    @include md-regular;

    .stepInfo {
      @include for-phone-only {
        text-align: center;
      }
    }

    .title {
      color: var(--neutral-90);

      @include for-phone-only {
        margin-bottom: 8px;
      }
    }

    .description {
      color: var(--neutral-40);
      margin-top: 4px;
      margin-bottom: 12px;
      max-width: 224px;
    }
  }
}

.graph {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 20px 0 12px 0;
  height: 9px;
}

.circle {
  background-color: var(--neutral-30);
  width: 9px;
  border-radius: 50%;
  height: 9px;
  flex-shrink: 0;
}

.triangle {
  background-color: var(--neutral-30);
  transform: rotate(30deg) skewX(-30deg) scale(1, 0.866);
  width: 5px;
  height: 5px;
  border-top-right-radius: 30%;
  margin-left: 4px;
  margin-right: 1px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    background-color: inherit;
    width: inherit;
    height: inherit;
    border-top-right-radius: inherit;
  }

  &:before {
    transform: rotate(-135deg) skewX(-45deg) scale(1.414, 0.707) translate(0, -50%);
  }

  &:after {
    transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.414) translate(50%);
  }
}

.line {
  width: 100%;
  height: 2px;
  border-radius: 3px;
  background: var(--neutral-30);

  &.gradientLine {
    background: linear-gradient(90deg, var(--neutral-30) 0%, rgba(194, 199, 209, 0) 100%);
  }
}

.dueDate {
  color: var(--neutral-40);
  border: 1px solid var(--neutral-10);
  max-width: 246px;
  display: flex;
  justify-content: space-between;
}

.selectedDueDateLabel {
  color: var(--neutral-90);
}

.durationInputs {
  display: flex;
  gap: 10px;

  @include for-phone-only {
    flex-direction: column;
    align-items: center;
  }
}

.customDueDateInput {
  position: relative;
  height: 36px;
  width: 98px;

  &:after {
    content: 'days';
    position: absolute;
    color: var(--neutral-40);
    top: 0;
    left: 30px;
    height: 36px;
    display: flex;
    align-items: center;
  }

  &.twoChars:after {
    left: 40px;
  }

  &.threeChars:after {
    left: 50px;
  }

  &.oneDay:after {
    content: 'day';
  }

  .customInputWrapper {
    height: 36px;
    border-radius: 8px;
  }
}

.statusPill {
  height: initial;
  min-height: 24px;
  white-space: break-spaces;
}
